import React, { useState, useEffect, useCallback, useRef } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { formatNumber } from "@mui/utils";
import {
  DialogButton,
  DialogGreyOutlinedButton,
  GreyOutlinedButton,
} from "../Button/CustomButton";
import Autocomplete from "@mui/material/Autocomplete";
import { colors, Typography } from "../../Styles/GlobalStyles/Variables";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import CustomizedTabs from "./CustomizedTabs";
import generalFunc from "../../Utils/generalFunc";
import moment from "moment";
import dayjs from "dayjs";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CircularProgress from "@mui/material/CircularProgress";

import {
  Grid,
  Button,
  Divider,
  FormControl,
  IconButton,
  TextField,
  FormHelperText,
  InputAdornment,
  OutlinedInput,
  Link,
} from "@mui/material";
import { Box } from "@mui/system";
import Iconify from "../Dashboard/Iconify";
import { EditIcon } from "../MuiDataTableTheme/MuiDataTableTheme";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { StyledDivider } from "../Divider/StyledDivider";
import { errors } from "../../Utils/ErrorMessages/loans";
import FileSaver from "file-saver";
import { LoanExcelFile } from "../ExcelFiles/loan";
import Dropzone, { useDropzone } from "react-dropzone";
import { BulkUploadBeforeIcon } from "../Icons/FileUploadIcons";
import BulkUploadAfterIcon from "../Icons/BulkUploadAfterIcon.gif";
import {
  addNewLoan,
  fetchLoans,
  emptyLoans,
  restoreLoanInitial,
  printPartners,
  downloadBulkLoan,
  addBulkLoan
} from "../../Actions";
import {
  DropActiveText,
  DropZoneFooter,
  DropZoneText,
  TemplateNameSection,
  TemplateSection,
  TemplateZone,
  dragdropActive,
  dragdropZone,
  errorColor,
  fileNameSection,
  filesUploadedZone,
} from "../../Styles/DragnDrop";
const getLoanState = (state) => state.loansReducer;
const getPartnerState = (state) => state.partnersReducer;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}


export default function AddNewLoanDialog(props) {
  const {
    openNewLoanDialog,
    handleCloseNewLoanDialog,
    formType,
    updateLoadingState,
  } = props;

  const ToastStyle = {
    backgroundColor: "#d56b66",
    color: colors.white,
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();

  const initialFormValues = {
    name: "",
    partnerId: 0,
    amount: "",
    sector: "",
    expiryDate: "",
  };

  const initialFormState = {
    nameError: false,
    nameErrorMsg: "",
    partnerError: false,
    partnerErrorMsg: "",
    amountError: false,
    amountErrorMsg: "",
    sectorError: false,
    sectorErrorMsg: "",
    expiryDateError: false,
    expiryDateErrorMsg: "",
    inputError: false,
    inputErrorMsg: "",
  };
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [formStates, setFormStates] = useState({ ...initialFormState });
  const [loadingButton, setLoadingButton] = useState(false);
  const [disable, setDisable] = useState(colors.primaryGreen);
  const [dateValue, setDateValue] = useState("");
  const [partnerSelect, setPartnerSelect] = useState([]);
  const [partnerValue, setPartnerValue] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [sectorValue, setSectorValue] = useState("");
  const [sectorName, setSectorName] = useState("");
  const [disableField, setDisableField] = useState(true);
  const { allPartnersDataForPrinting } = useSelector(getPartnerState);
  const { loanCreated, bulkUploadData } = useSelector(getLoanState);
  const [allPartnersData, setAllPartnersData] = useState([]);

  const [partnerOpen, setPartnerOpen] = useState(false);
  const [partnerOptions, setPartnerOptions] = useState([]);
  const partnerLoading = partnerOpen && partnerOptions.length === 0;

  const [sectorOpen, setSectorOpen] = useState(false);
  const [sectorOptions, setSectorOptions] = useState([]);
  const sectorLoading = sectorOpen && sectorOptions.length === 0;

  const uploadedItemRef = useRef(null);
  const [value, setValue] = React.useState(0);
  const [bulkFileUpload, setBulkFileUpload] = useState(null);
  const initialBulkFileValues = {
    name: "",
    path: "",
    size: "",
    display: false,
    error: false,
    emptyError: false,
  };
  const [bulkFile, setBulkFile] = useState(initialBulkFileValues);
  const handleDeleteFile = () => {
    setBulkFile(initialBulkFileValues);
    setBulkFileUpload(null);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  function MyDropzone() {
    const onDrop = useCallback((acceptedFiles) => {
      uploadedItemRef?.current?.scrollIntoView({ behavior: "smooth" });
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result;
          console.log(binaryStr, "binarystring");
          console.log(reader, "reader");
          console.log(file, "file");
          if (!file.name.match(/\.(xlsx)$/)) {
            setBulkFile({
              ...bulkFile,
              error: true,
              display: false,
              name: "",
              path: "",
              size: "",
            });
            setBulkFileUpload(null);
            return false;
          } else {
            setBulkFileUpload(file);
            setBulkFile({
              ...bulkFile,
              name: file.name,
              size: file.size,
              display: true,
              error: false,
              emptyError: false,
            });
          }
        };
        reader.readAsArrayBuffer(file);
        console.log(reader.readAsArrayBuffer(file), "as array buffer");
      });
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
    });

    return (
      <>
        <div
          style={isDragActive ? dragdropActive : dragdropZone}
          {...getRootProps()}
        >
          <div>
            {/* <img src={Folder} alt="folder" width="70px" height="50px" /> */}
          </div>
          <br />
          <input {...getInputProps()} />
          {isDragActive ? (
            <>
              <div style={{ textAlign: "center" }}>
                <img
                  src={BulkUploadAfterIcon}
                  alt="file upload"
                  width={50}
                  height={50}
                />
                <p style={DropActiveText}>
                  {" "}
                  <b>Drop file here...</b>
                </p>
              </div>
            </>
          ) : (
            <>
              <div style={{ textAlign: "center" }}>
                <BulkUploadBeforeIcon />
                <p style={DropZoneText}>Upload the filled-in template here</p>
                <p style={{ fontSize: "10px" }}>
                  Drag and drop, or click to select
                </p>
              </div>
            </>
          )}
        </div>
        <div style={DropZoneFooter}>
          <div>
            <p>File must be in .xlsx</p>
          </div>
          <div>
            <p>Maximum Size: 20MB</p>
          </div>
        </div>
      </>
    );
  }

  
  // const handleDownload =(e)=>{
  //   e.preventDefault();
  //   // let dataBlob = LoanExcelFile;
  //   let sliceSize = 1024;
  //   let byteCharacters = atob(LoanExcelFile)
  //   let bytelength = byteCharacters.length
  //   let sliceCount = Math.ceil(bytelength/sliceSize)
  //   let byteArrays = new Array(sliceCount)
  //   for(let sliceIndex= 0; sliceIndex<sliceCount; ++sliceIndex){
  //     let begin = sliceIndex * sliceSize;
  //     let end = Math.min(begin+sliceSize, bytelength)
  //     let bytes = new Array(end-begin);
  //     for(var offset = begin, i=0; offset<end; ++i, ++offset){
  //       bytes[i]= byteCharacters[offset].charCodeAt(0)
  //     }
  //     byteArrays[sliceIndex] = new Uint8Array(bytes)
  //   }
  //   let blob = new Blob(byteArrays, {type:"application/vnd.ms-excel"})
  //   FileSaver.saveAs(new Blob([blob],{}), "Loan-Template.xlsx")
  // }

  const handleDownload = () => {
    dispatch(downloadBulkLoan());
    return false;
   };

  const addBulkUploadLoan = () => {
    debugger;
    if (bulkFile?.name !== "") {
      const formData = new FormData();
      formData.append("File", bulkFileUpload);
      dispatch(addBulkLoan(formData));
      setLoadingButton(true);
      setDisable(colors.secondaryGreen);
    } else {
      setBulkFile({ ...bulkFile, emptyError: true });
    }
    setTimeout(() => {
      if (dispatch) {
        setLoadingButton(false);
      }
    }, 2000);
  };

  const addNewLoans = (e) => {
    debugger;
    e.preventDefault();
    debugger;
    if (
      Object.values(formValues).every(
        (value) =>
          value !== "" &&
          (value !== " " || value === "0" || value === "1" || value === 1)
      )
    ) {
      setLoadingButton(true);
      dispatch(addNewLoan(formValues));
    } else {
      if (
        formValues.name === "" ||
        formValues.name === " " ||
        formValues.partnerId === 0 ||
        formValues.amount === "" ||
        formValues.sector === "" ||
        formValues.expiryDate === ""
      ) {
        setFormStates({
          ...formStates,
          nameError: formValues.name === "" || formValues.name === " ",
          nameErrorMsg:
            formValues.name === "" || formValues.name === " "
              ? errors.name
              : "",
          partnerError: formValues.partnerId === 0,
          partnerErrorMsg: formValues.partnerId === 0 ? errors.partner : "",
          amountError: formValues.amount === "",
          amountErrorMsg: formValues.amount === "" ? errors.amount : "",
          sectorError: formValues.sector === "",
          sectorErrorMsg: formValues.sector === "" ? errors.sector : "",
          expiryDateError: formValues.expiryDate === "",
          expiryDateErrorMsg:
            formValues.expiryDate === "" ? errors.expiryDate : "",
        });
      }
    }
  };

  //This effect populates the partners select options
  useEffect(() => {
    const createPartnerSelect = () => {
      let partnerData = [];

      allPartnersDataForPrinting.map((key) => {
        let option = { value: key.id, label: key.name };
        return partnerData.push(option);
      });
      setPartnerSelect(partnerData);
    };
    allPartnersDataForPrinting.length !== 0 && createPartnerSelect();
  }, [allPartnersDataForPrinting, dispatch]);

  useEffect(() => {
    let active = true;

    if (!partnerLoading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);
      if (active) {
        setPartnerOptions(partnerSelect);
      }
    })();

    return () => {
      active = false;
    };
  }, [partnerLoading]);

  useEffect(() => {
    if (!partnerOpen) {
      setPartnerOptions([]);
    }
  }, [partnerOpen]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const handleClose = () => {
    dispatch(restoreLoanInitial());
    setFormValues({
      ...initialFormValues,
    });
    setFormStates({
      ...initialFormState,
    });
    handleCloseNewLoanDialog();
    setLoadingButton(false);
    setSectorValue("");
    setPartnerValue("");
    setDateValue("");
  };

  const LoanNameHandler = (e) => {
    if (e) {
      let loanNameValue = e.target.value;

      if (loanNameValue === "") {
        setFormStates({
          ...formStates,
          nameError: true,
          nameErrorMsg: errors.name,
        });
        setFormValues({
          ...formValues,
          name: loanNameValue,
        });
      } else if (loanNameValue !== " " && loanNameValue.length > 0) {
        setFormStates({
          ...formStates,
          nameError: false,
          nameErrorMsg: "",
        });
        setFormValues({
          ...formValues,
          name: loanNameValue,
        });
      }
    }
  };

  const AmountHandler = (e) => {
    if (e) {
      let amountValue = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);

      if (amountValue === "") {
        setFormStates({
          ...formStates,
          amountError: true,
          amountErrorMsg: errors.amount,
        });
      } else if (amountValue !== " " && amountValue.length > 0) {
        setFormStates({
          ...formStates,
          amountError: false,
          amountErrorMsg: "",
        });
        setFormValues({
          ...formValues,
          amount: amountValue,
        });
      }
    }
  };
  const PartnerHandler = (event, val) => {
    if (event) {
      setPartnerValue(val.value);
      setPartnerName(val.label);

      if (val.value !== 0) {
        setFormStates({
          ...formStates,
          partnerError: false,
          partnerErrorMsg: "",
        });
        setFormValues({
          ...formValues,
          partnerId: val.value,
        });
      } else {
        setFormStates({
          ...formStates,
          partnerError: true,
          partnerErrorMsg: errors.partner,
        });
        setFormValues({
          ...formValues,
          partnerId: val.value,
        });
      }
    }
  };
  const SectorHandler = (event, val) => {
    if (event) {
      setSectorValue(val.value);
      setSectorName(val.label);

      if (val.value !== null) {
        setFormStates({
          ...formStates,
          sectorError: false,
          sectorErrorMsg: "",
        });
        setFormValues({
          ...formValues,
          sector: val.value,
        });
      } else {
        setFormStates({
          ...formStates,
          sectorError: true,
          sectorErrorMsg: errors.sector,
        });
        setFormValues({
          ...formValues,
          sector: val.value,
        });
      }
    }
  };

  // const ExpiryDateHandler = (e) => {
  //   if(e){
  //     let dateValue = e.target.value;
  //     setFormValues({
  //       ...formValues,
  //       expiryDate: dateValue,
  //     });
  //   }
  // }

  function resetForm() {
    setFormValues({
      ...formValues,
      name: "",
      partnerId: 0,
      amount: "",
      sector: "",
      expiryDate: "",
    });
  }

  // this effect checks if loan is created and then closes the dialog and resetForm
  useEffect(() => {
    if (loanCreated === true || bulkUploadData === true) {
      handleClose();
      setLoadingButton(true);
      updateLoadingState();
      dispatch(fetchLoans());
      resetForm();
      setError(false);
      setHelperText("");
    }
    return () => {
      dispatch(emptyLoans());
      dispatch(restoreLoanInitial());
      setLoadingButton(false);
    };
  }, [loanCreated, bulkUploadData, dispatch]);

  const top100Films = [
    { label: "The Shawshank Redemption", year: 1994 },
    { label: "The Godfather", year: 1972 },
    { label: "The Godfather: Part II", year: 1974 },
    { label: "The Dark Knight", year: 2008 },
  ];

  const SECTORS = {
    Agriculture: 0,
    Construction: 1,
    Finance: 2,
    Education: 3,
    ICT: 4,
    Energy: 5,
    Entertainment: 6,
    Health: 7,
    Hospitality: 8,
    Manufacturing: 9,
    Mining: 10,
    Telecommunications: 11,
    Transportation: 12,
  };

  const sectorSelect = Object.keys(SECTORS).map((sector) => ({
    label: sector,
    value: SECTORS[sector],
  }));

  useEffect(() => {
    let active = true;

    if (!sectorLoading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);
      if (active) {
        setSectorOptions(sectorSelect);
      }
    })();

    return () => {
      active = false;
    };
  }, [sectorLoading]);

  useEffect(() => {
    if (!sectorOpen) {
      setSectorOptions([]);
    }
  }, [sectorOpen]);

  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
        fullWidth="lg"
        fullScreen={fullScreen}
        open={openNewLoanDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: { borderRadius: 20, padding: 10 },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          id="responsive-dialog-title"
        >
          Add New Loan
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "0px 10px",
            textTransform: "capitalize",
            "&::-webkit-scrollbar": {
              width: 5,
              height: 5,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#fff",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#DCDCDC",
              borderRadius: 2,
            },
          }}
        >
          <CustomizedTabs
          value={value}
          handleChange={handleChange}
                Item1={
          <Box
            component="form"
            sx={{
              "& > :not(style)": { p: 3 },
            }}
            noValidate
            autoComplete="off"
          >
            <FormControl variant="outlined" fullWidth>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <label
                    style={{
                      marginBottom: "10px",
                      marginTop: "20px",
                      fontSize: "14px",
                      fontFamily: Typography.secondaryFont,
                    }}
                    for="loanname"
                  >
                    Loan Name
                  </label>
                  <TextField
                    inputProps={{
                      spellCheck: true,
                      lang: "English",
                    }}
                    size="small"
                    id="loanname"
                    variant="outlined"
                    value={generalFunc.firstLetterUppercase(formValues.name)}
                    error={formStates.nameError}
                    helperText={formStates.nameErrorMsg}
                    onChange={(e) => LoanNameHandler(e)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <label
                    style={{
                      marginBottom: "10px",
                      marginTop: "20px",
                      fontSize: "14px",
                      fontFamily: Typography.secondaryFont,
                    }}
                    for="partner"
                  >
                    Partner
                  </label>
                  {/* <Autocomplete
                            disablePortal
                            id="partner"
                            sx={{ width: 225}}
                            value={partnerValue}
                            
                            // defaultValue={{
                            //   value: formValues.partnerId,
                            // }}
                            renderInput={(params) => <TextField {...params} 
                            error={formStates.partnerError}
                            helperText={formStates.partnerErrorMsg}
                            size="small"/>}
                            onChange={(event, value) => {
                              if (value) {
                                PartnerHandler(event, value);
                                setPartnerValue(value);
                              }
                            }}
                            options={partnerOptions}
                            getOptionLabel={(option) =>
                              option.label ? option.label : ""
                            }
                          /> */}
                  <Autocomplete
                    onKeyDown={handleKeyDown}
                    autoHighlight
                    id="asynchronous-demo"
                    sx={{ width: 225 }}
                    open={partnerOpen}
                    onOpen={() => {
                      setPartnerOpen(true);
                    }}
                    onClose={() => {
                      setPartnerOpen(false);
                    }}
                    value={partnerValue || ""}
                    onChange={(event, value) => {
                      if (value) {
                        PartnerHandler(event, value);
                        setPartnerValue(value);
                      }
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.label === value.label
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    options={partnerOptions}
                    loading={partnerLoading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        error={formStates?.partnerError}
                        helperText={formStates?.partnerErrorMsg}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {partnerLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <label
                    style={{
                      marginBottom: "10px",
                      marginTop: "20px",
                      fontSize: "14px",
                      fontFamily: Typography.secondaryFont,
                    }}
                    for="amount"
                  >
                    Amount
                  </label>
                  <TextField
                    size="small"
                    id="amount"
                    variant="outlined"
                    error={formStates.amountError}
                    helperText={formStates.amountErrorMsg}
                    value={formValues.amount}
                    onChange={(e) => AmountHandler(e)}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                        pattern: "[0-9]*",
                        maxLength: 12, // Set a maximum length for the input field
                      },
                      startAdornment: (
                        <InputAdornment position="start">₦</InputAdornment>
                      ), // Add a Naira sign to the beginning of the input field
                      value:
                        formValues.amount !== ""
                          ? new Intl.NumberFormat().format(formValues.amount)
                          : "",
                    }}
                  />
                  {/* <TextField
                            inputProps={{
                              // style: { height: "20px" },
                              spellCheck: true,
                              lang: "English",
                              
                            }}
                            size="small"
                            id="amount"
                            variant="outlined"
                            error={formStates.amountError}
                            helperText={formStates.amountErrorMsg}
                            value={formValues.amount}
                            onChange={(e)=>AmountHandler(e)}
                          /> */}
                </Grid>
                <Grid item xs={6}>
                  <label
                    style={{
                      marginBottom: "10px",
                      marginTop: "20px",
                      fontSize: "14px",
                      fontFamily: Typography.secondaryFont,
                    }}
                    for="sector"
                  >
                    Sector
                  </label>
                  <Autocomplete
                    onKeyDown={handleKeyDown}
                    autoHighlight
                    id="asynchronous-demo"
                    sx={{ width: 225 }}
                    open={sectorOpen}
                    onOpen={() => {
                      setSectorOpen(true);
                    }}
                    onClose={() => {
                      setSectorOpen(false);
                    }}
                    value={sectorValue || ""}
                    onChange={(event, value) => {
                      if (value) {
                        SectorHandler(event, value);
                        setSectorValue(value);
                      }
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.label === value.label
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    options={sectorOptions}
                    loading={sectorLoading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        error={formStates.sectorError}
                        helperText={formStates.sectorErrorMsg}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {sectorLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                  {/* <Autocomplete
                            disablePortal
                            id="sector"
                            sx={{ width: 225}}
                            value={sectorValue}
                            
                              // defaultValue={{
                              //   value: formValues.sector,
                              // }}
                            renderInput={(params) => <TextField {...params} 
                            error={formStates.sectorError}
                            helperText={formStates.sectorErrorMsg}
                            size="small" />}
                            onChange={(event, value) => {
                              if (value) {
                                SectorHandler(event, value);
                                setSectorValue(value);
                              }
                            }}
                            options={sectorOptions}
                            getOptionLabel={(option) =>
                              option.label ? option.label : ""
                            }
                          /> */}
                </Grid>
                <Grid item xs={"6"}>
                  <label
                    style={{
                      marginBottom: "10px",
                      marginTop: "20px",
                      fontSize: "14px",
                      fontFamily: Typography.secondaryFont,
                    }}
                    for="expirydate"
                  >
                    Expiry Date
                  </label>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      disablePast
                      openTo="year"
                      views={["year", "month", "day"]}
                      sx={{ width: 50 }}
                      inputFormat="DD-MM-YYYY"
                      value={dateValue}
                      onChange={(newValue) => {
                        setDateValue(newValue);

                        if (dateValue === "") {
                          setFormStates({
                            ...formStates,
                            expiryDateError: true,
                            expiryDateErrorMsg: errors.expiryDate,
                          });
                          setFormValues({
                            ...formValues,
                            expiryDate: newValue?.toISOString() || "",
                          });
                        } else {
                          setFormStates({
                            ...formStates,
                            expiryDateError: false,
                            expiryDateErrorMsg: "",
                          });
                          setFormValues({
                            ...formValues,
                            expiryDate: newValue?.toISOString() || "",
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // error={false}
                          error={formStates.expiryDateError}
                          helperText={formStates.expiryDateErrorMsg}
                          size="small"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </FormControl>
          </Box>
                }
                Item2={
                  <Box
                    component="form"
                    sx={{
                      "& > :not(style)": { pt: 2, pb: 0, pl: 2 },
                      fontFamily: Typography.secondaryFont,
                      textTransform: "initial",
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Box>
                  <div style={{ marginTop: "2px" }}>
                    {bulkFile.error ? (
                      <p style={errorColor}>
                        You can only upload file in .XLSX format{" "}
                      </p>
                    ) : bulkFile.emptyError ? (
                      <p style={errorColor}>Please upload a file to submit</p>
                    ) : (
                      ""
                    )}
                    <MyDropzone />
                  </div>
                  {bulkFile.display ? (
                    <div style={filesUploadedZone} ref={uploadedItemRef}>
                      <div style={fileNameSection}>
                        <div
                          style={{
                            backgroundColor: "#fff",
                            padding: "7px",
                            border: "1.3px solid #e0e0e0",
                            borderRadius: "7pX",
                            width: "fit-content",
                          }}
                        >
                          <Iconify
                            icon="vscode-icons:file-type-excel"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </div>
                        <div>
                          <p style={{ fontWeight: 600 }}>{bulkFile.name}</p>
                          <p style={{ marginTop: "10px", fontWeight: 400 }}>
                            {Math.round(bulkFile.size / 1024)} KB
                          </p>
                        </div>
                      </div>
                      <>
                        <IconButton
                          size="small"
                          sx={{ marginTop: "-15px" }}
                          onClick={handleDeleteFile}
                        >
                          <CloseIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      </>
                    </div>
                  ) : (
                    <div style={TemplateZone} ref={uploadedItemRef}>
                      <div>
                        <div style={TemplateNameSection}>
                          <div>
                            {" "}
                            <Iconify
                              icon="vscode-icons:file-type-excel"
                              style={{ width: "30px", height: "30px" }}
                            />
                          </div>

                          <div>
                            <p style={{ fontWeight: 600 }}>
                              Loans Template Sheet
                            </p>
                          </div>
                        </div>
                        <div>
                          <p
                            style={{
                              marginTop: "10px",
                              fontWeight: 400,
                              color: "9DA3AA",
                              width: "90%",
                            }}
                          >
                            Download the sample template by clicking on the
                            download button. Add your data to the template file
                            and upload the file for submission.{" "}
                          </p>
                        </div>
                      </div>
                      <>
                        <Button
                          onClick={handleDownload}
                          variant="outlined"
                          disableElevation
                          sx={{
                            fontSize: "13px",
                            padding: "10px 25px",
                            background: "#fff",
                            border: "1.3px solid #e0e0e0",
                            borderRadius: "5px",
                            textTransform: "initial",
                            color: "gray",
                            "&:hover": { background: "#fff", color: "#016c34" },
                          }}
                        >
                          Download
                        </Button>
                      </>
                    </div>
                  )}
                </Box>
              </Box>
            }
          />
        </DialogContent>

        <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>
          <GreyOutlinedButton
            sx={{ fontFamily: Typography.secondaryFont, padding: "10px 25px" }}
            autoFocus
            onClick={handleClose}
          >
            {formType === "view" ? <>Close</> : <>Cancel</>}
          </GreyOutlinedButton>
          <LoadingButton
            loading={loadingButton}
            onClick={value === 0 ? addNewLoans : addBulkUploadLoan}
            sx={{
              textTransform: "capitalize",
              color: "#fff",
              borderColor: colors.primaryGreen,
              padding: "10px 30px",
              "&:hover": { borderColor: colors.primaryGreen },
            }}
            variant="contained"
          >
            Add New Loan
          </LoadingButton>
        </DialogActions>
        <ToastContainer toastStyle={ToastStyle} />
      </Dialog>
    </ThemeProvider>
  );
}
